<template>
    <div class="cart-total sticky-top">
        <h4 class="cart-total-heading">Данные о заказе</h4>
        <div class="cart-total-items">
            <div class="cart-total-item">
                <span>Товаров в корзине:</span>
                <span> </span>
                <span>{{ activeItemsCount }}</span>
            </div>
            <div class="cart-total-item">
                <span>Общая стоимость:</span>
                <span></span>
                <span>{{ $root.priceFormat(totalPriceWithoutDiscount) }} &#x20bd;</span>
            </div>
            <div v-if="totalDiscount" class="cart-total-item">
                <span>Скидка К-С:</span>
                <span></span>
                <span>{{ $root.priceFormat(totalDiscount) }} &#x20bd;</span>
            </div>
            <div v-if="clientId && clientCardDiscount" class="cart-total-item">
                <span>Скидка по карте клиента:</span>
                <span></span>
                <span>{{ $root.priceFormat(clientCardDiscount) }} &#x20bd;</span>
            </div>
            <div v-if="promoCode && promoCodeDiscount" class="cart-total-item">
                <span>Скидка по промо коду {{ promoCode }}:</span>
                <span></span>
                <span>{{ $root.priceFormat(promoCodeDiscount) }} &#x20bd;</span>
            </div>
            <div v-if="bonusDiscount" class="cart-total-item">
                <span>Бонусные баллы:</span>
                <span></span>
                <span>{{ $root.priceFormat(bonusDiscount) }} &#x20bd;</span>
            </div>

            <div v-if="deliveryMethod" class="cart-total-item">
                <span>Доставка ({{ deliveryMethod }})</span>
                <span v-if="deliveryCost !== false"></span>
                <span v-if="deliveryCost !== false">{{ deliveryCost ? deliveryCost + ' &#x20bd;' : 'Бесплатно' }}</span>
            </div>

            <div class="cart-total-item-adress">
                <span v-if="addressLine">{{ addressLine}}</span>
                <span v-if="pickupPointLabel">{{ pickupPointLabel}}</span>
            </div>

            <div class="cart-total-item">
                <span>ИТОГО К ОПЛАТЕ:</span>
                <span></span>
                <span>{{ $root.priceFormat(greatTotalPrice) }} &#x20bd;</span>
            </div>
        </div>

        <q-btn @click.prevent="submitOrder" label="Оформить заказ" class="full-width" />

        <div class="cart-total-accept">
            Нажимая на кнопку «Оформить заказ», вы принимаете условия <a href="javascript: void(0)" @click="$root.redirect('/offer/')" title="Публичная оферта">Публичной оферты</a>
        </div>
        <div class="cart-total-accept">
            <input id="subscribe-by-order" name="subscribe-by-order" type="checkbox" v-model="subscribe">
            <label for="subscribe-by-order">Подписка на рассылку всех акций и уникальных предложений</label>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
    name: 'CartTotal',
    props: {
        disabled: {
            type: Boolean,
            required: false
        }
    },
    methods: {
        ...mapActions('cart', [
            'submit',
        ]),

        submitOrder () {
            let _this = this;

                if (!this.submitting) {
                    _this.$store.commit('cart/updateStatusSubmitting', true);
                    _this.submit();
                }
            }
        },
        computed: {
            ...mapState('cart', [
                'itemsCount',
                'promoCode',
                'submitting',
                'items',
                'clientId',
            ]),
            ...mapGetters('cart', [
                'activeItemsCount',
                'inactiveItemsCount',
                'totalPriceWithoutDiscount',
                'totalDiscount',
                'clientCardDiscount',
                'promoCodeDiscount',
                'totalPrice',
                'pickupPointLabel',
                'exceedCountThreshold',
                'hasError',
                'getError',
                'bonusDiscount',
            ]),
            ...mapGetters('asset', [
                'deliveryMethodName',
            ]),
            ...mapGetters('delivery', {
                getDeliveryCost: 'deliveryCost',
            }),
            ...mapGetters('customer', [
                'getAddressById',
            ]),
            nextStepDisabled () {
                return this.exceedCountThreshold || !!this.inactiveItemsCount;
            },
            greatTotalPrice () {
                return this.totalPrice + (this.deliveryCost ? this.deliveryCost : 0);
            },
            deliveryMethod () {
                let deliveryMethodId = this.$store.state.cart.form.delivery_method_id;

            return deliveryMethodId ? this.deliveryMethodName(deliveryMethodId) : '';
        },
        deliveryCost () {
            let _this = this;

            let deliveryMethodId = _this.$store.state.cart.form.delivery_method_id;
            let serviceId = _this.$store.state.cart.form.service_id;
            let regionId = _this.$store.state.cart.form.address.region.id;
            let cityId = _this.$store.state.cart.form.address.city.id;
            let paymentTypeId = _this.$store.state.cart.form.payment_type_id;

            if (_this.totalPrice < 3000) {
                paymentTypeId = 1;
            }

            return deliveryMethodId && serviceId && regionId && cityId && paymentTypeId
                ? _this.getDeliveryCost(deliveryMethodId, serviceId, regionId, cityId, paymentTypeId)
                : false;
        },
        addressLine () {
            let addressId = this.$store.state.cart.form.address_id;

            if (addressId) {
                return this.getAddressById(addressId).address_line;
            }

            let address = this.$store.state.cart.form.address;
            let addressLine = '';

            if (address.region_name && address.city_name) {
                addressLine += address.region_name + (address.region_type_short ? ' ' + address.region_type_short : '') + ', '
                    + (address.city_type_short ? address.city_type_short + ' ' : '') + address.city_name
                    + (address.district_name
                        ? ' (' + address.district_name + ' ' + address.district_type_short + ')'
                        : '');
            }

            return addressLine;
        },
        subscribe: {
            get () {
                return this.$store.state.cart.form.subscribe === 1;
            },
            set (value) {
                this.$store.commit('cart/setFormValue', {
                    key: 'subscribe',
                    value: value ? 1 : 0
                });
            }
        },
        accept: {
            get () {
                return this.$store.state.cart.form.accept === 1;
            },
            set (value) {
                this.$store.commit('cart/setFormValue', {
                    key: 'accept',
                    value: value ? 1 : 0
                });
            }
        },
    }
}
</script>
